module.exports = __webpack_public_path__ + "img/sec-9.5a96fd5e.png";